import styled, { css } from 'styled-components';
import {CssRule} from "../../../../themes/architecture/css-helpers/css-rule";

export const dialogTextMixin = css`
    color: ${({theme}) => theme.colors.textLight};
    font-size: 1.5rem;
    text-align: center;
    .dialog-form & {
      text-align: left
    }
`;

export const dialogHighlightedTextMixin = css`
    color: ${props => props.theme.colors.brandPrimary};
    font-size: 1.5rem;
    text-align: center;
    .dialog-form & {
      text-align: left
    }
`;

export const DialogTextBox = styled.div`
    margin-top: 2rem;
    ${dialogTextMixin}
    @media ${({theme}) => theme.mediaQuery.veryLowHeight} {
      ${CssRule.For.landscape.build()} & {
        margin-top: 0.5rem;
      }
    }
`;

export const DialogBoldTextBox = styled(DialogTextBox)`
    font-weight: bold;
    ${dialogTextMixin}
`;

export const DialogHighlightedTextBox = styled.div`
    margin-top: 2rem;
    ${dialogHighlightedTextMixin}
    @media ${({theme}) => theme.mediaQuery.veryLowHeight} {
      ${CssRule.For.landscape.build()} & {
        margin-top: 0.5rem;
      }
    }
`;

export const ListDialogTextBox = styled.div`
    color: ${({theme}) => theme.colors.textContrast};
    margin-top: 4rem;
    font-size: 1.5rem;
    text-align: left;
`;

export const DialogDimmedTextBox = styled.div` 
    margin-top: 2rem;
    font-size: 1.4rem;
    text-align: center;
    color: ${({theme}) => theme.colors.textMiddleDark};
    `;